export default __webpack_public_path__ + "static/media/Plantilla_Dash.7f43e20f.svg";